// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.76.1/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer[data-v-32223b2a],footer a[data-v-32223b2a],footer a[data-v-32223b2a]:active,footer a[data-v-32223b2a]:focus,footer a[data-v-32223b2a]:hover{color:#fff}footer .inner-footer>.cell[data-v-32223b2a]:not(:last-child){padding-top:4rem}footer .inner-footer>.cell[data-v-32223b2a]:last-child{padding-top:1rem;padding-bottom:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
